import React, {useEffect} from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../../ui/Dialog/DialogActions";
import Button from "../../../../../../../../ui/Button";
import SelectStudentTable from "./SelectStudentTable";
import {getStudentList} from "../../../../../../../../Study/Students/store/actions";
import {connect} from "react-redux";

const styles = theme => ({
  dialog: {
    width: "550px"
  }
});

const AddExist = ({
                     open,
                     handleClose,
                      masterClassId,
                    masterClassName,
                    handleAccept,
                    getStudentList,
                    studentList,
                     classes,
                     history
                   }) => {
  const [person, setPerson] = React.useState(null);

  useEffect(() => {
    getStudentList();
  }, []);

  const onChangePerson = (value) => {
    setPerson(value);
  };

  const onConfirm = () => {
    handleAccept(masterClassId, person);
    onClose();
  };

  const onClose = () => {
    setPerson(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>{`Записать студента на мастер-класс "${masterClassName}"`}</DialogTitle>
        <DialogContent>
          {studentList &&
          <SelectStudentTable selectedPerson={person}
                              onSelectedPerson={p => onChangePerson(p)}
                              personList={studentList}/>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  studentList: state.studyStudents.studentList
});

const mapDispatchToProps = dispatch => ({
  getStudentList: () => dispatch(getStudentList())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddExist));
